import { ComponentPropsWithoutRef, FC } from 'react';

export type SearchIconProps = ComponentPropsWithoutRef<'svg'>;

export const SearchIcon: FC<SearchIconProps> = ({ fill, ...props }) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="14"
            height="14"
            viewBox="0 0 14 14"
            fill="none"
            {...props}
        >
            <path
                d="M12.8053 13.5024L7.91159 8.60654C7.50044 8.92279 7.04844 9.16384 6.55559 9.3297C6.06276 9.49556 5.55998 9.57849 5.04728 9.57849C3.77664 9.57849 2.69803 9.13502 1.81144 8.24806C0.924859 7.36108 0.481567 6.28469 0.481567 5.01889C0.481567 3.7531 0.924324 2.67602 1.80984 1.78766C2.69534 0.899313 3.77172 0.455139 5.03898 0.455139C6.30625 0.455139 7.38405 0.899084 8.2724 1.78697C9.16075 2.67485 9.60492 3.75259 9.60492 5.0202C9.60492 5.55203 9.51759 6.06544 9.34292 6.56041C9.16824 7.05538 8.93159 7.50029 8.63298 7.89512L13.5288 12.7788L12.8053 13.5024ZM5.04325 8.57933C6.04059 8.57933 6.88367 8.23542 7.5725 7.5476C8.26134 6.85979 8.60576 6.01604 8.60576 5.01635C8.60576 4.01665 8.26134 3.17306 7.5725 2.48556C6.88367 1.79806 6.03992 1.45431 5.04125 1.45431C4.04259 1.45431 3.1995 1.79822 2.512 2.48604C1.8245 3.17386 1.48075 4.01761 1.48075 5.01729C1.48075 6.01698 1.82462 6.86058 2.51234 7.54808C3.20006 8.23558 4.0437 8.57933 5.04325 8.57933Z"
                fill={fill ?? 'currentColor'}
            />
        </svg>
    );
};
